import React from "react";
import { Button, Column, Icon, Modal, Row, Text } from "@amzn/meridian";
import checkCircleTokens from "@amzn/meridian-tokens/base/icon/check-circle";

interface BarcodeConfirmationModalProps {
  open: boolean;
  barcode: string;
  onConfirm: () => void;
  onRescan: () => void;
}

const BarcodeConfirmationModal: React.FC<BarcodeConfirmationModalProps> = ({
  open,
  barcode,
  onConfirm,
  onRescan,
}) => {
  return (
    <Modal open={open}>
      <Column spacing="500" spacingInset="600" alignmentHorizontal="center">
        {/* Success Icon */}
        <Icon tokens={checkCircleTokens} color="success" />

        {/* Heading */}
        <Column alignmentHorizontal="center">
          <Text type="h300">Barcode Scanned Successfully</Text>
        </Column>

        {/* Barcode Display */}
        <Column spacing="200" width="100%">
          <Text type="b200" color="secondary">
            Scanned Barcode:
          </Text>
          <div
            style={{
              padding: "16px",
              backgroundColor: "#F5F5F5",
              borderRadius: "8px",
              border: "1px solid #D3D3D3",
            }}
          >
            <div
              style={{
                fontFamily: "monospace",
                fontSize: "18px",
                wordBreak: "break-all",
                textAlign: "center",
                display: "block",
              }}
            >
              {barcode}
            </div>
          </div>
        </Column>

        {/* Verification Instruction */}
        <Column alignmentHorizontal="center">
          <Text type="b100" color="secondary">
            Please verify the barcode is correct before continuing.
          </Text>
        </Column>

        {/* Action Buttons */}
        <Row spacing="300" width="100%" alignmentHorizontal="center">
          <Button type="secondary" size="large" onClick={onRescan}>
            Rescan
          </Button>
          <Button type="primary" size="large" onClick={onConfirm}>
            Continue
          </Button>
        </Row>
      </Column>
    </Modal>
  );
};

export default BarcodeConfirmationModal;
